import { ChainDefaultId, ChainId, CurrencyAmount, ERC20Token, NATIVE, Pair, Token } from "@pancakeswap/sdk"
// import BigNumber from "bignumber.js"
import { LP_HOLDERS_FEE, WEEKS_IN_YEAR } from "config/constants/info"
import { useAllTokens } from "hooks/Tokens"
import { useMemo } from "react"
import { useFarms, usePollFarmsWithUserData } from "state/farms/hooks"
import useSWRImmutable from "swr/immutable"
import { safeGetAddress } from "utils"
import addresses from 'config/constants/contracts'
import { v3Clients } from "utils/graphql"
import { fetchAllPoolDataWithAddressOld } from "state/info/queries/pools/poolData"
import { useStableSwapPairs } from "state/swap/useStableSwapPairs"
import { gql } from "graphql-request"
import { PositionData } from "views/V3Info/types"
import axios from "axios"
import { formatEther, formatUnits, parseEther, parseUnits } from "viem"
import { PositionMath } from "@pancakeswap/v3-sdk"
import { useWatchlistPools } from "state/user/hooks"
import { usePools } from "./usePools"

const API_ENDPOINT = `https://api.scan.pulsechain.com/api/v2`
const SWR_SETTINGS = {
    refreshInterval: 10000,
    keepPreviousData: true,
    errorRetryCount: 3,
    errorRetryInterval: 3000,
}

// export function useTokenBalances(account: string) {
//     return useSWRImmutable(
//         account ? [`api/tokens/balances/${account}`] : undefined,
//         () => {
//             return fetch(`${API_ENDPOINT}/addresses/${account}/token-balances`).then(res => res.json())
//         }, SWR_SETTINGS,
//     )
// }

export function useTokenBalances(account: string) {
    // console.log('useTokenBalances', `${API_ENDPOINT}/addresses/${account}/token-balances`)
    return useSWRImmutable(
        account ? [`api/tokens/balances/${account}`] : undefined,
        () => {
            // return axios.get(`${MORALIS_API}/wallets/${account}/tokens?chain=pulse`, {
            //     headers: {
            //         'accept': 'application/json',
            //         'X-API-Key': MORALIS_API_KEY
            //     }
            // }).then(({ data }) => {
            //     return data.result.filter(row => row.balance).map(row => ({
            //         token: row.native_token
            //             ? NATIVE[ChainDefaultId]
            //             : new ERC20Token(ChainDefaultId, row.token_address, row.decimals, row.symbol, row.name),
            //         price: Number(row.usd_price),
            //         balance: Number(row.balance_formatted),
            //         totalSupply: Number(row.total_supply_formatted),
            //     }))
            // }).catch(ex => console.error(ex))
            return fetch(`${API_ENDPOINT}/addresses/${account}/token-balances`).then(res => res.json())
                .then((data: any[]) => 
                    data.filter(row => row.token.type === "ERC-20" && !['pDex StableSwap LP', 'pDEX'].includes(row.token.name))
                        .map(row => ({
                            token: new ERC20Token(ChainDefaultId, row.token.address, Number(row.token.decimals), row.token.symbol, row.token.name),
                            balance: Number(formatUnits(row.value, Number(row.token.decimals))),
                            totalSupply: Number(formatUnits(row.token.total_supply, Number(row.token.decimals)))
                        })
                ))
                .catch(() => [])
        }, SWR_SETTINGS,
    )
}

// export function useNFTBalances(account: string) {
//     return useSWRImmutable(
//         account ? [`api/nft/balances/${account}`] : undefined,
//         () => {
//             return fetch(`${API_ENDPOINT}/addresses/${account}/nft?type=ERC-721`)
//                 .then(async (res) => {
//                     const data = await res.json()
//                     return data.items.filter(item => item.token.address === addresses.nftPositionManager[ChainId.PULSE]).map(item => Number(item.id))
//                 })
//         }, SWR_SETTINGS
//     )
// }

export type PositionV2Data = {
    address: string
    token0: ERC20Token
    token1: ERC20Token
    feeTier: number
    liquidity: number
    token0Deposited: number
    token1Deposited: number
    volume: number
    fee: number
    apr: number
    apr7d: number
    balance: number
    totalSupply: number
    staked: number
    keyword: string
}

export type PositionStableData = {
    address: string
    token0: ERC20Token
    token1: ERC20Token
    token2?: ERC20Token
    feeTier: number
    liquidity: number
    token0Deposited: number
    token1Deposited: number
    token2Deposited: number
    volume: number
    fee: number
    apr: number
    apr7d: number
    balance: number
    totalSupply: number
    keyword: string
}

export function useV2Positions(account: string) {
    // const { chainId } = useActiveChainId()
    const { data: balances = [], isLoading, status } = useTokenBalances(account)
    const { data: farms, userDataLoaded: farmsLoaded } = useFarms()
    // console.log('balances', balances)

    // const tokens = useAllTokens()
    usePollFarmsWithUserData()
    const pairBalances: { [address: string]: number } = useMemo(() => {
        if (!isLoading && status === "success" && balances) {
            return balances.filter(({ token }) => token.name === "🍆 9 LP").reduce((result, { token, balance }) => ({ ...result, [token.address]: balance }), {})
        }
        return {}
    }, [balances, isLoading, status])
    const pairSupplies: { [address: string]: number } = useMemo(() => {
        if (!isLoading && status === "success" && balances) {
            return balances.filter(({ token }) => token.name === "🍆 9 LP").reduce((result, { token, totalSupply }) => ({ ...result, [token.address]: totalSupply }), {})
        }
        return {}
    }, [balances, isLoading, status])
    const farmingBalances: { [address: string]: number } = useMemo(() => {
        if (!farmsLoaded)
            return {}
        return farms.reduce((prev, farm) => {
            if (farm.userData && farm.userData.stakedBalance?.gt(0))
                return {
                    ...prev, [farm.lpAddress]: Number(formatEther(BigInt(farm.userData.stakedBalance.toString())))
                }
            return prev
        }, {})
    }, [farmsLoaded, farms])

    const [watchlistPools] = useWatchlistPools()

    const lpAddresses = useMemo(() => [...(new Set([
        ...watchlistPools,
        ...Object.keys(pairBalances),
        ...Object.keys(farmingBalances),
    ]))], [farmingBalances, pairBalances, watchlistPools])
    const { data: pools } = usePools(lpAddresses.map(addr => addr.toLowerCase()))
    // console.log('pools', pools)
    return useMemo(() => {
        return {
            data: pools?.filter(pool => pool.version === 'v2').map((pool) => {
                const address = safeGetAddress(pool.address)
                const balance = pairBalances[address]
                const totalSupply = pairSupplies[address]
                if (balance > 0)
                    return {
                        address,
                        token0: pool.token0,
                        token1: pool.token1,
                        feeTier: 0.29,
                        liquidity: Math.max(0, pool.liquidity * balance / totalSupply),
                        token0Deposited: Number(pool.reserve0 * balance / totalSupply),
                        token1Deposited: Number(pool.reserve1 * balance / totalSupply),
                        volume: Math.max(0, pool.volume1d),
                        fee: Math.max(0, pool.fee1d),
                        apr: pool.apr1d,
                        apr7d: pool.apr7d,
                        balance,
                        totalSupply,
                        staked: farmingBalances[address] ?? 0,
                        keyword: `${pool.token0.name} ${pool.token0.symbol} ${pool.token1.name} ${pool.token1.symbol}`,
                    } satisfies PositionV2Data
                return undefined
            }).filter(Boolean) ?? [],
            loading: !pools
        }
    }, [pools, pairSupplies, pairBalances, farmingBalances])
}

export function useStablePositions(account: string) {
    // const { chainId } = useActiveChainId()
    const { data: balances, isLoading, status } = useTokenBalances(account)

    // const tokens = useAllTokens()
    // const stableSwapPairs = useStableSwapPairs()
    const pairBalances: { [address: string]: number } = useMemo(() => {
        if (!isLoading && status === "success" && balances) {
            return balances.filter(({ token }) => token.name === "Nineinch StableSwap LPs").reduce((result, { token, balance }) => ({ ...result, [token.address]: balance }), {})
        }
        return {}
    }, [balances, isLoading, status])
    const pairSupplies: { [address: string]: number } = useMemo(() => {
        if (!isLoading && status === "success" && balances) {
            return balances.filter(({ token }) => token.name === "Nineinch StableSwap LPs").reduce((result, { token, totalSupply }) => ({ ...result, [token.address]: totalSupply }), {})
        }
        return {}
    }, [balances, isLoading, status])
    const lpAddresses = useMemo(() => Object.keys(pairBalances).filter(Boolean).map(addr => addr.toLowerCase()), [pairBalances])
    const { data: pools } = usePools(lpAddresses)
    return useMemo(() => {
        return {
            data: pools?.map((pool) => {
                const address = safeGetAddress(pool.address)
                const balance = pairBalances[address]
                const totalSupply = pairSupplies[address]
                // const pair = stableSwapPairs.find(stablePair => safeGetAddress(stablePair.lpAddress) === address)
                return {
                    address,
                    token0: pool.token0,
                    token1: pool.token1,
                    token2: pool.token2,
                    liquidity: Math.max(0, pool.liquidity * balance / totalSupply),
                    token0Deposited: pool.reserve0 * balance / totalSupply,
                    token1Deposited: pool.reserve1 * balance / totalSupply,
                    token2Deposited: pool.reserve2 * balance / totalSupply,
                    volume: Math.max(0, pool.volume1d),
                    totalSupply,
                    feeTier: 0.01,
                    fee: Math.max(0, pool.fee1d),
                    apr: pool.apr1d,
                    apr7d: pool.apr7d,
                    balance,
                    keyword: `${pool.token0.name} ${pool.token0.symbol} ${pool.token1.name} ${pool.token1.symbol}`
                } satisfies PositionStableData
            }).filter(Boolean) ?? [],
            loading: !pools
        }
    }, [pools, pairBalances, pairSupplies])
}


export const POSITIONS_QUERY = (account: string) => {
    return gql`
      query {
        positions (
          where: {
            liquidity_gt: 0
            owner: "${account && account.length > 0 ? account.toLowerCase() : ""}"
          }
        ) {
          tokenId: id
          liquidity
          pool {
            id tick sqrtPrice
          }
          tickLower {
            tickIdx
          }
          tickUpper {
            tickIdx
          }
          depositedToken0
          depositedToken1
          token0 {
            decimals price: derivedUSD
          }
          token1 {
            decimals price: derivedUSD
          }
        }
        bundles(where: {id: "1"}) {
          ethPriceUSD
        }
      }
    `
}

async function fetchPositionDatas(
    account: string,
) {
    try {
        const data = await v3Clients[ChainId.PULSE].request<any>(POSITIONS_QUERY(account))
        return data.positions.map(position => {
            const tick = Number(position.pool.tick)
            const tickLower = Number(position.tickLower.tickIdx)
            const tickUpper = Number(position.tickUpper.tickIdx)
            const sqrtRatioX96 = BigInt(position.pool.sqrtPrice)
            const liquidity = BigInt(position.liquidity)
            const liquidityToken0 = Number(formatUnits(PositionMath.getToken0Amount(tick, tickLower, tickUpper, sqrtRatioX96, liquidity), Number(position.token0.decimals)))
            const liquidityToken1 = Number(formatUnits(PositionMath.getToken1Amount(tick, tickLower, tickUpper, sqrtRatioX96, liquidity), Number(position.token1.decimals)))
            return {
                tokenId: BigInt(position.tokenId),
                address: position.pool.id,
                liquidity,
                tick,
                tickLower,
                tickUpper,
                token0USD: Number(position.token0.price) * liquidityToken0,
                token1USD: Number(position.token1.price) * liquidityToken1,
                liquidityToken0,
                liquidityToken1,
            } satisfies PositionData
        })
    } catch (e) {
        console.error(e)
    }
    return {
        positions: [], pools: []
    }
}

export function useV3Positions(account: string) {
    const { data: positions, isLoading } = useSWRImmutable(
        [`info/positions/v3/${account}`],
        () => fetchPositionDatas(account),
        SWR_SETTINGS
    )

	const [watchlistPools] = useWatchlistPools()

    const lpAddresses: string[] = useMemo(() => {
        if (positions && positions.length > 0) {
            return [...watchlistPools, ...new Set(positions.map(p => p.address))] as string[]
        }
        return []
    }, [watchlistPools, positions])

    const { data: pools } = usePools(lpAddresses.map(addr => addr.toLowerCase()))
    
    return useMemo(() => {
        return {
            data: pools?.filter(pool => pool.version === 'v3').map((pool) => {
                const myPositions = positions.filter(p => p.address === pool.address)
                if (myPositions.length === 0)
                    return undefined
                return {
                    positions: myPositions,
                    pool,
                    // balance: pairBalances[safeGetAddress(pool.address)],
                    // staked: farmingBalances[safeGetAddress(pool.address)],
                }
            }).filter(Boolean) ?? [],
            loading: !pools
        }
    }, [pools, positions])
}